<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle" id="main-content" tabindex="-1">
      {{ pageTitle }}
    </h1>
    <h2 class="govuk-heading-m">{{ verifyPageText }}</h2>
    @if(webhookResponseStatus) {
      <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
    }


    @if(paymentAlreadyPaid) {
      <div [innerHTML]="'COMMON.PAYMENT_ALREADY_PAID' | translate: { serviceId: ref }"></div>
    }

    @if(maxRetriesReached) {
      <div class="govuk-notification-banner" role="region" aria-labelledby="payment-verify-notification-banner-title"
        data-module="govuk-notification-banner">
        <div class="govuk-notification-banner__header">
          <h2 class="govuk-notification-banner__title" id="payment-verify-notification-banner-title">
            Important
          </h2>
        </div>
        <div class="govuk-notification-banner__content"
          [innerHTML]="'COMMON.PAYMENT_MAX_RETRIES_REACHED' | translate: { serviceId: ref || receipt || basket }"></div>
      </div>
    }
  </div>

  @if(failed) {
    <div class="govuk-grid-column-two-thirds">
      <h1 class="govuk-heading-l">Sorry, there has been a problem</h1>
      <p class="govuk-body">Try again later.</p>
      <p class="govuk-body">Charge ID: {{ chargeId }}</p>
      <p class="govuk-body">Receipt: {{ receipt }}</p>
      <p class="govuk-body">Internal ref: {{ ref }}</p>
      <button type="submit" class="btn btn-primary return-button" (click)="restartJourney()">
        {{ 'CONFIRMATION.RETURN_HOME' | translate }}
      </button>
    </div>
  }
</div>

